import { arabicRegex as ArRegex } from "../_constants/ValidationPatterns";
export function isArabic(text: string): boolean {
    if (!text) return false;
    const arabicRegex = ArRegex;
    return arabicRegex.test(text);
}